<template>
  <div class="phone">
    <svg
      width="192"
      height="349"
      viewBox="0 0 192 349"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-2-inside-1" fill="white">
        <path
          d="M181.541 69.5397H182.416C182.738 69.5397 183 69.7782 183 70.0725V111.63C183 111.925 182.738 112.163 182.416 112.163H181.541V69.5397Z"
        />
      </mask>
      <g filter="url(#filter0_i)">
        <path
          d="M181.541 69.5397H182.416C182.738 69.5397 183 69.7782 183 70.0725V111.63C183 111.925 182.738 112.163 182.416 112.163H181.541V69.5397Z"
          fill="url(#paint0_linear)"
        />
      </g>
      <path
        d="M181.541 69.5397V67.5397H179.541V69.5397H181.541ZM181.541 112.163H179.541V114.163H181.541V112.163ZM181.541 71.5397H182.416V67.5397H181.541V71.5397ZM181 70.0725V111.63H185V70.0725H181ZM182.416 110.163H181.541V114.163H182.416V110.163ZM183.541 112.163V69.5397H179.541V112.163H183.541ZM181 111.63C181 110.653 181.809 110.163 182.416 110.163V114.163C183.668 114.163 185 113.196 185 111.63H181ZM182.416 71.5397C181.809 71.5397 181 71.0499 181 70.0725H185C185 68.5065 183.668 67.5397 182.416 67.5397V71.5397Z"
        fill="#292929"
        fill-opacity="0.2"
        style="mix-blend-mode: multiply"
        mask="url(#path-2-inside-1)"
      />
      <mask id="path-4-inside-2" fill="white">
        <path
          d="M181.541 125.749H182.416C182.738 125.749 183 125.988 183 126.282V144.131C183 144.425 182.738 144.664 182.416 144.664H181.541V125.749Z"
        />
      </mask>
      <g filter="url(#filter1_i)">
        <path
          d="M181.541 125.749H182.416C182.738 125.749 183 125.988 183 126.282V144.131C183 144.425 182.738 144.664 182.416 144.664H181.541V125.749Z"
          fill="url(#paint1_linear)"
        />
      </g>
      <path
        d="M181.541 125.749V123.749H179.541V125.749H181.541ZM181.541 144.664H179.541V146.664H181.541V144.664ZM181.541 127.749H182.416V123.749H181.541V127.749ZM181 126.282V144.131H185V126.282H181ZM182.416 142.664H181.541V146.664H182.416V142.664ZM183.541 144.664V125.749H179.541V144.664H183.541ZM181 144.131C181 143.153 181.809 142.664 182.416 142.664V146.664C183.668 146.664 185 145.697 185 144.131H181ZM182.416 127.749C181.809 127.749 181 127.26 181 126.282H185C185 124.716 183.668 123.749 182.416 123.749V127.749Z"
        fill="#292929"
        fill-opacity="0.2"
        style="mix-blend-mode: multiply"
        mask="url(#path-4-inside-2)"
      />
      <mask id="path-6-inside-3" fill="white">
        <path
          d="M13.1383 19.286C10 23.9624 10 30.3282 10 43.0598V305.94C10 318.672 10 325.038 13.1383 329.714C14.8943 332.331 17.3036 334.531 20.1692 336.134C24.7548 338.7 30.8237 338.969 42.0524 338.997C42.1595 338.997 42.213 338.997 42.2552 338.992C42.2924 338.987 42.2904 338.987 42.3267 338.978C42.3678 338.968 42.469 338.927 42.6713 338.846C42.8508 338.774 43.0493 338.734 43.258 338.734H44.7167C44.9268 338.734 45.1266 338.774 45.3071 338.847C45.5095 338.929 45.6107 338.97 45.6518 338.981C45.6881 338.99 45.686 338.989 45.7232 338.994C45.7655 339 45.818 339 45.9232 339C46.5775 339 47.2319 339 47.8863 339C47.9914 339 48.044 339 48.0862 338.994C48.1234 338.989 48.1213 338.99 48.1576 338.981C48.1987 338.97 48.2999 338.929 48.5023 338.847C48.6828 338.774 48.8826 338.734 49.0927 338.734H50.5514C50.7616 338.734 50.9614 338.774 51.1419 338.847C51.3443 338.929 51.4455 338.97 51.4866 338.981C51.5228 338.99 51.5208 338.989 51.558 338.994C51.6002 339 51.6528 339 51.7579 339H53.721C53.8261 339 53.8787 339 53.9209 338.994C53.9582 338.989 53.9561 338.99 53.9923 338.981C54.0334 338.97 54.1346 338.929 54.337 338.847C54.5175 338.774 54.7173 338.734 54.9275 338.734H56.3862C56.5963 338.734 56.7961 338.774 56.9766 338.847C57.179 338.929 57.2802 338.97 57.3213 338.981C57.3576 338.99 57.3555 338.989 57.3927 338.994C57.4349 339 57.4875 339 57.5926 339H59.5557C59.6609 339 59.7134 339 59.7557 338.994C59.7929 338.989 59.7908 338.99 59.8271 338.981C59.8682 338.97 59.9694 338.929 60.1718 338.847C60.3523 338.774 60.5521 338.734 60.7622 338.734H62.2209C62.4311 338.734 62.6308 338.774 62.8114 338.847C63.0138 338.929 63.115 338.97 63.1561 338.981C63.1923 338.99 63.1902 338.989 63.2275 338.994C63.2697 339 63.3222 339 63.4274 339H65.3905C65.4956 339 65.5482 339 65.5904 338.994C65.6276 338.989 65.6255 338.99 65.6618 338.981C65.7029 338.97 65.8041 338.929 66.0065 338.847C66.187 338.774 66.3868 338.734 66.597 338.734H68.0556C68.2658 338.734 68.4656 338.774 68.6461 338.847C68.8485 338.929 68.9497 338.97 68.9908 338.981C69.0271 338.99 69.025 338.989 69.0622 338.994C69.1044 339 69.157 339 69.2621 339H85.8121C85.9172 339 85.9698 339 86.012 338.994C86.0492 338.989 86.0471 338.99 86.0834 338.981C86.1245 338.97 86.2257 338.929 86.4281 338.847C86.6086 338.774 86.8084 338.734 87.0185 338.734H105.106C105.316 338.734 105.516 338.774 105.697 338.847C105.899 338.929 106 338.97 106.041 338.981C106.078 338.99 106.076 338.989 106.113 338.994C106.155 339 106.208 339 106.313 339H122.863C122.968 339 123.02 339 123.063 338.994C123.1 338.989 123.098 338.99 123.134 338.981C123.175 338.97 123.276 338.929 123.479 338.847C123.659 338.774 123.859 338.734 124.069 338.734H125.528C125.738 338.734 125.938 338.774 126.118 338.847C126.321 338.929 126.422 338.97 126.463 338.981C126.499 338.99 126.497 338.989 126.534 338.994C126.577 339 126.629 339 126.734 339H128.697C128.803 339 128.855 339 128.897 338.994C128.935 338.989 128.932 338.99 128.969 338.981C129.01 338.97 129.111 338.929 129.313 338.847C129.494 338.774 129.694 338.734 129.904 338.734H131.363C131.573 338.734 131.772 338.774 131.953 338.847C132.155 338.929 132.257 338.97 132.298 338.981C132.334 338.99 132.332 338.989 132.369 338.994C132.411 339 132.464 339 132.569 339H134.532C134.637 339 134.69 339 134.732 338.994C134.769 338.989 134.767 338.99 134.803 338.981C134.845 338.97 134.946 338.929 135.148 338.847C135.329 338.774 135.528 338.734 135.739 338.734H137.197C137.407 338.734 137.607 338.774 137.788 338.847C137.99 338.929 138.091 338.97 138.132 338.981C138.169 338.99 138.167 338.989 138.204 338.994C138.246 339 138.299 339 138.404 339H140.367C140.472 339 140.525 339 140.567 338.994C140.604 338.989 140.602 338.99 140.638 338.981C140.679 338.97 140.78 338.929 140.983 338.847C141.163 338.774 141.363 338.734 141.573 338.734H143.032C143.242 338.734 143.442 338.774 143.622 338.847C143.825 338.929 143.926 338.97 143.967 338.981C144.003 338.99 144.001 338.989 144.039 338.994C144.081 339 144.133 339 144.238 339C144.893 339 145.547 339 146.202 339C146.307 339 146.359 339 146.402 338.994C146.439 338.989 146.437 338.99 146.473 338.98C146.514 338.97 146.615 338.929 146.818 338.847C146.998 338.774 147.198 338.734 147.408 338.734H148.867C149.075 338.734 149.274 338.774 149.453 338.846C149.655 338.927 149.756 338.967 149.798 338.978C149.834 338.987 149.832 338.986 149.869 338.991C149.911 338.997 149.965 338.997 150.072 338.996C161.208 338.966 167.244 338.689 171.81 336.134C174.675 334.531 177.085 332.331 178.841 329.714C181.979 325.038 181.979 318.672 181.979 305.94V43.0598C181.979 30.3282 181.979 23.9624 178.841 19.286C177.085 16.6693 174.675 14.4692 171.81 12.8657C166.688 10 159.717 10 145.774 10H46.2046C32.2618 10 25.2905 10 20.1692 12.8657C17.3036 14.4692 14.8943 16.6693 13.1383 19.286Z"
        />
      </mask>
      <g filter="url(#filter2_ii)">
        <path
          d="M13.1383 19.286C10 23.9624 10 30.3282 10 43.0598V305.94C10 318.672 10 325.038 13.1383 329.714C14.8943 332.331 17.3036 334.531 20.1692 336.134C24.7548 338.7 30.8237 338.969 42.0524 338.997C42.1595 338.997 42.213 338.997 42.2552 338.992C42.2924 338.987 42.2904 338.987 42.3267 338.978C42.3678 338.968 42.469 338.927 42.6713 338.846C42.8508 338.774 43.0493 338.734 43.258 338.734H44.7167C44.9268 338.734 45.1266 338.774 45.3071 338.847C45.5095 338.929 45.6107 338.97 45.6518 338.981C45.6881 338.99 45.686 338.989 45.7232 338.994C45.7655 339 45.818 339 45.9232 339C46.5775 339 47.2319 339 47.8863 339C47.9914 339 48.044 339 48.0862 338.994C48.1234 338.989 48.1213 338.99 48.1576 338.981C48.1987 338.97 48.2999 338.929 48.5023 338.847C48.6828 338.774 48.8826 338.734 49.0927 338.734H50.5514C50.7616 338.734 50.9614 338.774 51.1419 338.847C51.3443 338.929 51.4455 338.97 51.4866 338.981C51.5228 338.99 51.5208 338.989 51.558 338.994C51.6002 339 51.6528 339 51.7579 339H53.721C53.8261 339 53.8787 339 53.9209 338.994C53.9582 338.989 53.9561 338.99 53.9923 338.981C54.0334 338.97 54.1346 338.929 54.337 338.847C54.5175 338.774 54.7173 338.734 54.9275 338.734H56.3862C56.5963 338.734 56.7961 338.774 56.9766 338.847C57.179 338.929 57.2802 338.97 57.3213 338.981C57.3576 338.99 57.3555 338.989 57.3927 338.994C57.4349 339 57.4875 339 57.5926 339H59.5557C59.6609 339 59.7134 339 59.7557 338.994C59.7929 338.989 59.7908 338.99 59.8271 338.981C59.8682 338.97 59.9694 338.929 60.1718 338.847C60.3523 338.774 60.5521 338.734 60.7622 338.734H62.2209C62.4311 338.734 62.6308 338.774 62.8114 338.847C63.0138 338.929 63.115 338.97 63.1561 338.981C63.1923 338.99 63.1902 338.989 63.2275 338.994C63.2697 339 63.3222 339 63.4274 339H65.3905C65.4956 339 65.5482 339 65.5904 338.994C65.6276 338.989 65.6255 338.99 65.6618 338.981C65.7029 338.97 65.8041 338.929 66.0065 338.847C66.187 338.774 66.3868 338.734 66.597 338.734H68.0556C68.2658 338.734 68.4656 338.774 68.6461 338.847C68.8485 338.929 68.9497 338.97 68.9908 338.981C69.0271 338.99 69.025 338.989 69.0622 338.994C69.1044 339 69.157 339 69.2621 339H85.8121C85.9172 339 85.9698 339 86.012 338.994C86.0492 338.989 86.0471 338.99 86.0834 338.981C86.1245 338.97 86.2257 338.929 86.4281 338.847C86.6086 338.774 86.8084 338.734 87.0185 338.734H105.106C105.316 338.734 105.516 338.774 105.697 338.847C105.899 338.929 106 338.97 106.041 338.981C106.078 338.99 106.076 338.989 106.113 338.994C106.155 339 106.208 339 106.313 339H122.863C122.968 339 123.02 339 123.063 338.994C123.1 338.989 123.098 338.99 123.134 338.981C123.175 338.97 123.276 338.929 123.479 338.847C123.659 338.774 123.859 338.734 124.069 338.734H125.528C125.738 338.734 125.938 338.774 126.118 338.847C126.321 338.929 126.422 338.97 126.463 338.981C126.499 338.99 126.497 338.989 126.534 338.994C126.577 339 126.629 339 126.734 339H128.697C128.803 339 128.855 339 128.897 338.994C128.935 338.989 128.932 338.99 128.969 338.981C129.01 338.97 129.111 338.929 129.313 338.847C129.494 338.774 129.694 338.734 129.904 338.734H131.363C131.573 338.734 131.772 338.774 131.953 338.847C132.155 338.929 132.257 338.97 132.298 338.981C132.334 338.99 132.332 338.989 132.369 338.994C132.411 339 132.464 339 132.569 339H134.532C134.637 339 134.69 339 134.732 338.994C134.769 338.989 134.767 338.99 134.803 338.981C134.845 338.97 134.946 338.929 135.148 338.847C135.329 338.774 135.528 338.734 135.739 338.734H137.197C137.407 338.734 137.607 338.774 137.788 338.847C137.99 338.929 138.091 338.97 138.132 338.981C138.169 338.99 138.167 338.989 138.204 338.994C138.246 339 138.299 339 138.404 339H140.367C140.472 339 140.525 339 140.567 338.994C140.604 338.989 140.602 338.99 140.638 338.981C140.679 338.97 140.78 338.929 140.983 338.847C141.163 338.774 141.363 338.734 141.573 338.734H143.032C143.242 338.734 143.442 338.774 143.622 338.847C143.825 338.929 143.926 338.97 143.967 338.981C144.003 338.99 144.001 338.989 144.039 338.994C144.081 339 144.133 339 144.238 339C144.893 339 145.547 339 146.202 339C146.307 339 146.359 339 146.402 338.994C146.439 338.989 146.437 338.99 146.473 338.98C146.514 338.97 146.615 338.929 146.818 338.847C146.998 338.774 147.198 338.734 147.408 338.734H148.867C149.075 338.734 149.274 338.774 149.453 338.846C149.655 338.927 149.756 338.967 149.798 338.978C149.834 338.987 149.832 338.986 149.869 338.991C149.911 338.997 149.965 338.997 150.072 338.996C161.208 338.966 167.244 338.689 171.81 336.134C174.675 334.531 177.085 332.331 178.841 329.714C181.979 325.038 181.979 318.672 181.979 305.94V43.0598C181.979 30.3282 181.979 23.9624 178.841 19.286C177.085 16.6693 174.675 14.4692 171.81 12.8657C166.688 10 159.717 10 145.774 10H46.2046C32.2618 10 25.2905 10 20.1692 12.8657C17.3036 14.4692 14.8943 16.6693 13.1383 19.286Z"
          fill="#2E2E32"
        />
      </g>
      <path
        d="M13.1383 19.286C10 23.9624 10 30.3282 10 43.0598V305.94C10 318.672 10 325.038 13.1383 329.714C14.8943 332.331 17.3036 334.531 20.1692 336.134C24.7548 338.7 30.8237 338.969 42.0524 338.997C42.1595 338.997 42.213 338.997 42.2552 338.992C42.2924 338.987 42.2904 338.987 42.3267 338.978C42.3678 338.968 42.469 338.927 42.6713 338.846C42.8508 338.774 43.0493 338.734 43.258 338.734H44.7167C44.9268 338.734 45.1266 338.774 45.3071 338.847C45.5095 338.929 45.6107 338.97 45.6518 338.981C45.6881 338.99 45.686 338.989 45.7232 338.994C45.7655 339 45.818 339 45.9232 339C46.5775 339 47.2319 339 47.8863 339C47.9914 339 48.044 339 48.0862 338.994C48.1234 338.989 48.1213 338.99 48.1576 338.981C48.1987 338.97 48.2999 338.929 48.5023 338.847C48.6828 338.774 48.8826 338.734 49.0927 338.734H50.5514C50.7616 338.734 50.9614 338.774 51.1419 338.847C51.3443 338.929 51.4455 338.97 51.4866 338.981C51.5228 338.99 51.5208 338.989 51.558 338.994C51.6002 339 51.6528 339 51.7579 339H53.721C53.8261 339 53.8787 339 53.9209 338.994C53.9582 338.989 53.9561 338.99 53.9923 338.981C54.0334 338.97 54.1346 338.929 54.337 338.847C54.5175 338.774 54.7173 338.734 54.9275 338.734H56.3862C56.5963 338.734 56.7961 338.774 56.9766 338.847C57.179 338.929 57.2802 338.97 57.3213 338.981C57.3576 338.99 57.3555 338.989 57.3927 338.994C57.4349 339 57.4875 339 57.5926 339H59.5557C59.6609 339 59.7134 339 59.7557 338.994C59.7929 338.989 59.7908 338.99 59.8271 338.981C59.8682 338.97 59.9694 338.929 60.1718 338.847C60.3523 338.774 60.5521 338.734 60.7622 338.734H62.2209C62.4311 338.734 62.6308 338.774 62.8114 338.847C63.0138 338.929 63.115 338.97 63.1561 338.981C63.1923 338.99 63.1902 338.989 63.2275 338.994C63.2697 339 63.3222 339 63.4274 339H65.3905C65.4956 339 65.5482 339 65.5904 338.994C65.6276 338.989 65.6255 338.99 65.6618 338.981C65.7029 338.97 65.8041 338.929 66.0065 338.847C66.187 338.774 66.3868 338.734 66.597 338.734H68.0556C68.2658 338.734 68.4656 338.774 68.6461 338.847C68.8485 338.929 68.9497 338.97 68.9908 338.981C69.0271 338.99 69.025 338.989 69.0622 338.994C69.1044 339 69.157 339 69.2621 339H85.8121C85.9172 339 85.9698 339 86.012 338.994C86.0492 338.989 86.0471 338.99 86.0834 338.981C86.1245 338.97 86.2257 338.929 86.4281 338.847C86.6086 338.774 86.8084 338.734 87.0185 338.734H105.106C105.316 338.734 105.516 338.774 105.697 338.847C105.899 338.929 106 338.97 106.041 338.981C106.078 338.99 106.076 338.989 106.113 338.994C106.155 339 106.208 339 106.313 339H122.863C122.968 339 123.02 339 123.063 338.994C123.1 338.989 123.098 338.99 123.134 338.981C123.175 338.97 123.276 338.929 123.479 338.847C123.659 338.774 123.859 338.734 124.069 338.734H125.528C125.738 338.734 125.938 338.774 126.118 338.847C126.321 338.929 126.422 338.97 126.463 338.981C126.499 338.99 126.497 338.989 126.534 338.994C126.577 339 126.629 339 126.734 339H128.697C128.803 339 128.855 339 128.897 338.994C128.935 338.989 128.932 338.99 128.969 338.981C129.01 338.97 129.111 338.929 129.313 338.847C129.494 338.774 129.694 338.734 129.904 338.734H131.363C131.573 338.734 131.772 338.774 131.953 338.847C132.155 338.929 132.257 338.97 132.298 338.981C132.334 338.99 132.332 338.989 132.369 338.994C132.411 339 132.464 339 132.569 339H134.532C134.637 339 134.69 339 134.732 338.994C134.769 338.989 134.767 338.99 134.803 338.981C134.845 338.97 134.946 338.929 135.148 338.847C135.329 338.774 135.528 338.734 135.739 338.734H137.197C137.407 338.734 137.607 338.774 137.788 338.847C137.99 338.929 138.091 338.97 138.132 338.981C138.169 338.99 138.167 338.989 138.204 338.994C138.246 339 138.299 339 138.404 339H140.367C140.472 339 140.525 339 140.567 338.994C140.604 338.989 140.602 338.99 140.638 338.981C140.679 338.97 140.78 338.929 140.983 338.847C141.163 338.774 141.363 338.734 141.573 338.734H143.032C143.242 338.734 143.442 338.774 143.622 338.847C143.825 338.929 143.926 338.97 143.967 338.981C144.003 338.99 144.001 338.989 144.039 338.994C144.081 339 144.133 339 144.238 339C144.893 339 145.547 339 146.202 339C146.307 339 146.359 339 146.402 338.994C146.439 338.989 146.437 338.99 146.473 338.98C146.514 338.97 146.615 338.929 146.818 338.847C146.998 338.774 147.198 338.734 147.408 338.734H148.867C149.075 338.734 149.274 338.774 149.453 338.846C149.655 338.927 149.756 338.967 149.798 338.978C149.834 338.987 149.832 338.986 149.869 338.991C149.911 338.997 149.965 338.997 150.072 338.996C161.208 338.966 167.244 338.689 171.81 336.134C174.675 334.531 177.085 332.331 178.841 329.714C181.979 325.038 181.979 318.672 181.979 305.94V43.0598C181.979 30.3282 181.979 23.9624 178.841 19.286C177.085 16.6693 174.675 14.4692 171.81 12.8657C166.688 10 159.717 10 145.774 10H46.2046C32.2618 10 25.2905 10 20.1692 12.8657C17.3036 14.4692 14.8943 16.6693 13.1383 19.286Z"
        stroke="#171717"
        stroke-width="2"
        mask="url(#path-6-inside-3)"
      />
      <g style="mix-blend-mode: multiply">
        <path
          d="M159.515 338.815V336.869H156.014V338.936C157.257 338.909 158.421 338.87 159.515 338.815Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M36.1105 338.939V336.869H32.6096V338.822C33.7041 338.876 34.8682 338.913 36.1105 338.939Z"
          fill="url(#paint3_linear)"
        />
      </g>
      <g style="mix-blend-mode: multiply">
        <path
          d="M32.6096 10.1773V12.1309H36.1105V10.0607C34.8682 10.0868 33.7041 10.1241 32.6096 10.1773Z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M156.014 10.0639V12.1309H159.515V10.1846C158.421 10.1296 157.257 10.091 156.014 10.0639Z"
          fill="url(#paint5_linear)"
        />
      </g>
      <g filter="url(#filter3_ddi)">
        <path
          d="M11.7507 43.2997C11.7507 31.0912 11.7507 24.987 14.7601 20.5028C16.4439 17.9936 18.7542 15.884 21.5021 14.3464C26.4128 11.5984 33.0977 11.5984 46.4674 11.5984H145.512C158.882 11.5984 165.567 11.5984 170.477 14.3464C173.225 15.884 175.536 17.9936 177.219 20.5028C180.229 24.987 180.229 31.0912 180.229 43.2997V305.7C180.229 317.909 180.229 324.013 177.219 328.497C175.536 331.007 173.225 333.116 170.477 334.654C165.567 337.402 158.882 337.402 145.512 337.402H46.4674C33.0977 337.402 26.4128 337.402 21.5021 334.654C18.7542 333.116 16.4439 331.007 14.7601 328.497C11.7507 324.013 11.7507 317.909 11.7507 305.7V43.2997Z"
          fill="#27262D"
        />
        <path
          d="M145.512 11.0984H46.4674H46.442C39.7786 11.0984 34.7473 11.0984 30.7694 11.4438C26.7808 11.7901 23.8016 12.4867 21.2579 13.9101C18.4444 15.4844 16.0744 17.6469 14.3449 20.2242C12.7767 22.5609 12.0101 25.2988 11.6296 28.9529C11.2507 32.5913 11.2507 37.1907 11.2507 43.2693V43.2997V305.7V305.731C11.2507 311.809 11.2507 316.409 11.6296 320.047C12.0101 323.701 12.7767 326.439 14.3449 328.776C16.0744 331.353 18.4444 333.516 21.2579 335.09C23.8016 336.513 26.7808 337.21 30.7694 337.556C34.7474 337.902 39.779 337.902 46.4427 337.902H46.4674H145.512H145.537C152.201 337.902 157.232 337.902 161.21 337.556C165.199 337.21 168.178 336.513 170.722 335.09C173.535 333.516 175.905 331.353 177.635 328.776C179.203 326.439 179.969 323.701 180.35 320.047C180.729 316.409 180.729 311.81 180.729 305.731V305.7V43.2997V43.2689C180.729 37.1905 180.729 32.5912 180.35 28.9529C179.969 25.2988 179.203 22.5609 177.635 20.2242C175.905 17.6469 173.535 15.4844 170.722 13.9101C168.178 12.4867 165.199 11.7901 161.21 11.4438C157.232 11.0984 152.201 11.0984 145.538 11.0984H145.512Z"
          stroke="white"
          stroke-opacity="0.42"
          style="mix-blend-mode: screen"
        />
      </g>
      <path
        d="M13.501 40.8221C13.501 30.1833 13.501 24.8639 16.1234 20.9563C17.5908 18.7697 19.604 16.9313 21.9986 15.5914C26.2779 13.1968 32.1033 13.1968 43.7541 13.1968H148.225C159.876 13.1968 165.701 13.1968 169.981 15.5914C172.375 16.9313 174.388 18.7697 175.856 20.9563C178.478 24.8639 178.478 30.1833 178.478 40.8221V308.178C178.478 318.817 178.478 324.136 175.856 328.044C174.388 330.23 172.375 332.069 169.981 333.409C165.701 335.803 159.876 335.803 148.225 335.803H43.7541C32.1033 335.803 26.2779 335.803 21.9986 333.409C19.604 332.069 17.5908 330.23 16.1234 328.044C13.501 324.136 13.501 318.817 13.501 308.178V40.8221Z"
        fill="url(#paint6_linear)"
      />
      <path
        d="M43.7541 13.6968H148.225C154.059 13.6968 158.403 13.6972 161.824 13.9942C165.239 14.2908 167.685 14.8798 169.736 16.0277C172.065 17.3309 174.019 19.1164 175.441 21.2349C176.688 23.0941 177.33 25.3101 177.653 28.4168C177.978 31.5331 177.978 35.4921 177.978 40.8221V308.178C177.978 313.508 177.978 317.467 177.653 320.583C177.33 323.69 176.688 325.906 175.441 327.765C174.019 329.884 172.065 331.669 169.736 332.972C167.685 334.12 165.239 334.709 161.824 335.006C158.403 335.303 154.059 335.303 148.225 335.303H43.7541C37.9199 335.303 33.5763 335.303 30.1553 335.006C26.7401 334.709 24.2941 334.12 22.2427 332.972C19.9138 331.669 17.9603 329.884 16.5386 327.765C15.2908 325.906 14.6496 323.69 14.3261 320.583C14.0016 317.467 14.001 313.508 14.001 308.178V40.8221C14.001 35.4921 14.0016 31.5331 14.3261 28.4168C14.6496 25.3101 15.2908 23.0941 16.5386 21.2349C17.9603 19.1164 19.9138 17.3309 22.2427 16.0277C24.2941 14.8798 26.7401 14.2908 30.1553 13.9942C33.5763 13.6972 37.9199 13.6968 43.7541 13.6968Z"
        stroke="white"
        stroke-opacity="0.4"
      />
      <g style="mix-blend-mode: color-dodge">
        <path
          d="M167.526 334.473C168.409 334.185 169.219 333.835 169.981 333.409C172.375 332.069 174.389 330.23 175.856 328.044C178.478 324.136 178.478 318.817 178.478 308.178V40.8221C178.478 30.1833 178.478 24.8639 175.856 20.9563C174.389 18.7697 172.375 16.9313 169.981 15.5914C169.219 15.1654 168.409 14.8151 167.526 14.5272C169.718 15.84 171.567 17.58 172.939 19.6243C175.561 23.532 175.561 28.8513 175.561 39.4901V309.51C175.561 320.149 175.561 325.468 172.939 329.376C171.567 331.42 169.718 333.16 167.526 334.473Z"
          fill="url(#paint7_linear)"
        />
      </g>
      <g style="mix-blend-mode: color-dodge">
        <path
          d="M24.4407 334.473C23.5574 334.185 22.7471 333.835 21.9858 333.409C19.5912 332.069 17.5779 330.23 16.1106 328.044C13.4882 324.136 13.4882 318.817 13.4882 308.178V40.8221C13.4882 30.1833 13.4882 24.8639 16.1106 20.9563C17.5779 18.7697 19.5912 16.9313 21.9858 15.5914C22.7471 15.1654 23.5574 14.8151 24.4406 14.5272C22.2489 15.84 20.3999 17.58 19.0279 19.6243C16.4055 23.532 16.4055 28.8513 16.4055 39.4901V309.51C16.4055 320.149 16.4055 325.468 19.0279 329.376C20.3999 331.42 22.2489 333.16 24.4407 334.473Z"
          fill="url(#paint8_linear)"
        />
      </g>
      <path
        d="M76.3701 325.947C76.3701 322.636 79.309 319.953 82.9342 319.953H109.191C112.816 319.953 115.755 322.636 115.755 325.947V325.947C115.755 329.257 112.816 331.941 109.191 331.941H82.9342C79.309 331.941 76.3701 329.257 76.3701 325.947V325.947Z"
        fill="black"
        style="mix-blend-mode: multiply"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M109.191 320.619H82.9342C79.7118 320.619 77.0995 323.004 77.0995 325.947C77.0995 328.889 79.7118 331.275 82.9342 331.275H109.191C112.413 331.275 115.025 328.889 115.025 325.947C115.025 323.004 112.413 320.619 109.191 320.619ZM82.9342 319.953C79.309 319.953 76.3701 322.636 76.3701 325.947C76.3701 329.257 79.309 331.941 82.9342 331.941H109.191C112.816 331.941 115.755 329.257 115.755 325.947C115.755 322.636 112.816 319.953 109.191 319.953H82.9342Z"
        fill="url(#paint9_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M109.191 320.619H82.9342C79.7118 320.619 77.0995 323.004 77.0995 325.947C77.0995 328.889 79.7118 331.275 82.9342 331.275H109.191C112.413 331.275 115.025 328.889 115.025 325.947C115.025 323.004 112.413 320.619 109.191 320.619ZM82.9342 319.953C79.309 319.953 76.3701 322.636 76.3701 325.947C76.3701 329.257 79.309 331.941 82.9342 331.941H109.191C112.816 331.941 115.755 329.257 115.755 325.947C115.755 322.636 112.816 319.953 109.191 319.953H82.9342Z"
        fill="url(#paint10_angular)"
        style="mix-blend-mode: overlay"
      />
      <path
        d="M76.9539 325.947C76.9539 322.931 79.6315 320.485 82.9345 320.485H109.191C112.494 320.485 115.171 322.931 115.171 325.947V325.947C115.171 328.963 112.494 331.408 109.191 331.408H82.9345C79.6315 331.408 76.9539 328.963 76.9539 325.947V325.947Z"
        fill="#17161A"
        fill-opacity="0.6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.9343 320.352H109.191C112.574 320.352 115.317 322.857 115.317 325.947C115.317 329.036 112.574 331.541 109.191 331.541H82.9343C79.5508 331.541 76.8079 329.036 76.8079 325.947C76.8079 322.857 79.5508 320.352 82.9343 320.352ZM82.9343 320.485C79.6313 320.485 76.9537 322.931 76.9537 325.947C76.9537 328.963 79.6313 331.408 82.9343 331.408H109.191C112.494 331.408 115.171 328.963 115.171 325.947C115.171 322.931 112.494 320.485 109.191 320.485H82.9343Z"
        fill="white"
        fill-opacity="0.08"
      />
      <path
        d="M16.5696 30C16.5696 23.3726 21.9422 18 28.5696 18H163.335C169.963 18 175.335 23.3726 175.335 30V310C175.335 313.314 172.649 316 169.335 316H22.5696C19.2559 316 16.5696 313.314 16.5696 310V30Z"
        fill="#0282F9"
      />
      <path
        d="M150.421 26V22.332H150.409L149.29 23.1377V22.5811L150.415 21.7725H150.931V26H150.421ZM154.013 26V25.1211H151.889V24.6436C152.07 24.3057 152.301 23.9199 152.58 23.4863C152.861 23.0527 153.249 22.4814 153.743 21.7725H154.522V24.6582H155.12V25.1211H154.522V26H154.013ZM152.41 24.6465V24.6582H154.013V22.2119H154.004C153.264 23.2686 152.732 24.0801 152.41 24.6465ZM156.292 25.9326C156.228 25.9971 156.148 26.0293 156.055 26.0293C155.961 26.0293 155.882 25.9971 155.817 25.9326C155.753 25.8682 155.721 25.7891 155.721 25.6953C155.721 25.6016 155.753 25.5225 155.817 25.458C155.882 25.3936 155.961 25.3613 156.055 25.3613C156.148 25.3613 156.228 25.3936 156.292 25.458C156.356 25.5225 156.389 25.6016 156.389 25.6953C156.389 25.7891 156.356 25.8682 156.292 25.9326ZM156.292 23.7764C156.228 23.8408 156.148 23.873 156.055 23.873C155.961 23.873 155.882 23.8408 155.817 23.7764C155.753 23.7119 155.721 23.6328 155.721 23.5391C155.721 23.4453 155.753 23.3662 155.817 23.3018C155.882 23.2373 155.961 23.2051 156.055 23.2051C156.148 23.2051 156.228 23.2373 156.292 23.3018C156.356 23.3662 156.389 23.4453 156.389 23.5391C156.389 23.6328 156.356 23.7119 156.292 23.7764ZM158.612 26.0703C158.208 26.0703 157.87 25.9561 157.599 25.7275C157.329 25.499 157.184 25.2051 157.162 24.8457H157.681C157.704 25.0703 157.803 25.2539 157.977 25.3965C158.15 25.5371 158.364 25.6074 158.618 25.6074C158.905 25.6074 159.139 25.5176 159.318 25.3379C159.5 25.1582 159.591 24.9258 159.591 24.6406C159.591 24.3555 159.5 24.1221 159.318 23.9404C159.139 23.7568 158.908 23.665 158.627 23.665C158.43 23.665 158.251 23.707 158.091 23.791C157.931 23.875 157.808 23.9912 157.722 24.1396H157.227L157.458 21.7725H159.878V22.2412H157.892L157.763 23.6182H157.774C157.87 23.4912 158.001 23.3916 158.167 23.3193C158.335 23.2471 158.52 23.2109 158.721 23.2109C159.127 23.2109 159.461 23.3447 159.723 23.6123C159.986 23.8779 160.118 24.2158 160.118 24.626C160.118 25.0498 159.978 25.3965 159.696 25.666C159.415 25.9355 159.054 26.0703 158.612 26.0703ZM162.198 26.0732C161.882 26.0732 161.603 25.9912 161.36 25.8271C161.118 25.6611 160.932 25.4258 160.801 25.1211C160.662 24.8008 160.593 24.4131 160.593 23.958C160.593 23.2451 160.736 22.6904 161.023 22.2939C161.312 21.8975 161.716 21.6992 162.233 21.6992C162.593 21.6992 162.899 21.7988 163.153 21.998C163.407 22.1973 163.568 22.4629 163.637 22.7949H163.101C163.044 22.6035 162.937 22.4512 162.778 22.3379C162.62 22.2227 162.437 22.165 162.228 22.165C161.874 22.165 161.601 22.3164 161.407 22.6191C161.214 22.9219 161.112 23.3545 161.103 23.917H161.111C161.207 23.71 161.362 23.5439 161.577 23.4189C161.792 23.2939 162.03 23.2314 162.292 23.2314C162.694 23.2314 163.028 23.3643 163.294 23.6299C163.562 23.8955 163.695 24.2285 163.695 24.6289C163.695 25.0469 163.554 25.3926 163.271 25.666C162.989 25.9375 162.632 26.0732 162.198 26.0732ZM161.507 25.3232C161.694 25.5107 161.923 25.6045 162.192 25.6045C162.462 25.6045 162.69 25.5117 162.878 25.3262C163.065 25.1406 163.159 24.9141 163.159 24.6465C163.159 24.3691 163.069 24.1416 162.89 23.9639C162.71 23.7842 162.48 23.6943 162.201 23.6943C161.922 23.6943 161.689 23.7832 161.504 23.9609C161.32 24.1387 161.229 24.3623 161.229 24.6318C161.229 24.9033 161.321 25.1338 161.507 25.3232Z"
        fill="white"
      />
      <rect x="16.5696" y="28.67" width="158.766" height="25" fill="#1890FF" />
      <path
        d="M50.7478 38.291L48.7966 45H47.8005L45.4978 36.5449H46.5994L48.2927 43.4473H48.3396L50.2439 36.5449H51.3103L53.2146 43.4473H53.2615L54.9548 36.5449H56.0564L53.7537 45H52.7576L50.8064 38.291H50.7478ZM57.0349 45V36.5449H58.0544V39.8789H58.0779C58.2498 39.5352 58.4998 39.2695 58.8279 39.082C59.1599 38.8945 59.5544 38.8008 60.0115 38.8008C60.6755 38.8008 61.199 39.0059 61.5818 39.416C61.9646 39.8262 62.156 40.375 62.156 41.0625V45H61.1365V41.25C61.1365 40.7578 61.0134 40.377 60.7673 40.1074C60.5251 39.8379 60.1677 39.7031 59.6951 39.7031C59.1912 39.7031 58.7908 39.8613 58.4939 40.1777C58.2009 40.4941 58.0544 40.918 58.0544 41.4492V45H57.0349ZM65.4607 44.2383C65.9412 44.2383 66.3435 44.0898 66.6677 43.793C66.9958 43.4922 67.1599 43.123 67.1599 42.6855V42.1875L65.531 42.2871C65.1208 42.3145 64.8025 42.4141 64.5759 42.5859C64.3533 42.7578 64.2419 42.9883 64.2419 43.2773C64.2419 43.5664 64.3533 43.7988 64.5759 43.9746C64.7986 44.1504 65.0935 44.2383 65.4607 44.2383ZM65.2322 45.1055C64.6267 45.1055 64.1365 44.9375 63.7615 44.6016C63.3904 44.2656 63.2048 43.8242 63.2048 43.2773C63.2048 42.7539 63.3962 42.3359 63.7791 42.0234C64.1658 41.7109 64.7107 41.5352 65.4138 41.4961L67.1599 41.3965V40.8867C67.1599 40.5156 67.0427 40.2246 66.8083 40.0137C66.574 39.8027 66.2458 39.6973 65.824 39.6973C65.4373 39.6973 65.1228 39.7832 64.8806 39.9551C64.6384 40.123 64.4841 40.3594 64.4177 40.6641H63.4333C63.4685 40.1211 63.7029 39.6758 64.1365 39.3281C64.574 38.9766 65.1443 38.8008 65.8474 38.8008C66.5623 38.8008 67.1287 38.9805 67.5466 39.3398C67.9685 39.6992 68.1794 40.1816 68.1794 40.7871V45H67.2126V43.9512H67.1892C67.0056 44.2988 66.7361 44.5781 66.3806 44.7891C66.0251 45 65.6423 45.1055 65.2322 45.1055ZM69.8025 37.4355H70.822V38.9062H72.0056V39.7441H70.822V43.3652C70.822 43.6426 70.8826 43.8477 71.0037 43.9805C71.1248 44.1094 71.3162 44.1738 71.5779 44.1738C71.7419 44.1738 71.8826 44.1641 71.9998 44.1445V45C71.8669 45.0312 71.6521 45.0469 71.3552 45.0469C70.7966 45.0469 70.3982 44.9219 70.1599 44.6719C69.9216 44.4219 69.8025 44.0039 69.8025 43.418V39.7441H68.8943V38.9062H69.8025V37.4355ZM72.99 40.5879C72.99 40.0645 73.2009 39.6367 73.6228 39.3047C74.0486 38.9688 74.5955 38.8008 75.2634 38.8008C75.8923 38.8008 76.4158 38.9688 76.8337 39.3047C77.2517 39.6406 77.4724 40.0664 77.4958 40.582H76.5232C76.488 40.2852 76.3552 40.0527 76.1248 39.8848C75.8982 39.7168 75.5994 39.6328 75.2283 39.6328C74.8572 39.6328 74.5583 39.7168 74.3318 39.8848C74.1052 40.0488 73.9919 40.2656 73.9919 40.5352C73.9919 40.9492 74.3298 41.2422 75.0056 41.4141L75.949 41.6426C76.5623 41.7988 76.9939 42.002 77.2439 42.252C77.4978 42.498 77.6248 42.8457 77.6248 43.2949C77.6248 43.8262 77.3982 44.2617 76.9451 44.6016C76.4919 44.9375 75.9099 45.1055 75.199 45.1055C74.5349 45.1055 73.9861 44.9414 73.5525 44.6133C73.1228 44.2812 72.8806 43.8438 72.8259 43.3008H73.8455C73.9587 43.9492 74.4314 44.2734 75.2634 44.2734C75.6736 44.2734 75.9978 44.1934 76.2361 44.0332C76.4783 43.8691 76.5994 43.6484 76.5994 43.3711C76.5994 43.1523 76.5271 42.9785 76.3826 42.8496C76.2419 42.7207 76.0017 42.6113 75.6619 42.5215L74.5896 42.2461C73.5232 41.9727 72.99 41.4199 72.99 40.5879ZM80.6951 44.2383C81.1755 44.2383 81.5779 44.0898 81.9021 43.793C82.2302 43.4922 82.3943 43.123 82.3943 42.6855V42.1875L80.7654 42.2871C80.3552 42.3145 80.0369 42.4141 79.8103 42.5859C79.5876 42.7578 79.4763 42.9883 79.4763 43.2773C79.4763 43.5664 79.5876 43.7988 79.8103 43.9746C80.033 44.1504 80.3279 44.2383 80.6951 44.2383ZM80.4666 45.1055C79.8611 45.1055 79.3708 44.9375 78.9958 44.6016C78.6248 44.2656 78.4392 43.8242 78.4392 43.2773C78.4392 42.7539 78.6306 42.3359 79.0134 42.0234C79.4001 41.7109 79.9451 41.5352 80.6482 41.4961L82.3943 41.3965V40.8867C82.3943 40.5156 82.2771 40.2246 82.0427 40.0137C81.8083 39.8027 81.4802 39.6973 81.0583 39.6973C80.6716 39.6973 80.3572 39.7832 80.115 39.9551C79.8728 40.123 79.7185 40.3594 79.6521 40.6641H78.6677C78.7029 40.1211 78.9373 39.6758 79.3708 39.3281C79.8083 38.9766 80.3787 38.8008 81.0818 38.8008C81.7966 38.8008 82.363 38.9805 82.781 39.3398C83.2029 39.6992 83.4138 40.1816 83.4138 40.7871V45H82.447V43.9512H82.4236C82.24 44.2988 81.9705 44.5781 81.615 44.7891C81.2595 45 80.8767 45.1055 80.4666 45.1055ZM87.6677 38.8008C88.449 38.8008 89.0779 39.0879 89.5544 39.6621C90.0349 40.2363 90.2751 41 90.2751 41.9531C90.2751 42.9023 90.0369 43.666 89.5603 44.2441C89.0837 44.8184 88.4607 45.1055 87.6912 45.1055C87.2615 45.1055 86.8767 45.0078 86.5369 44.8125C86.197 44.6172 85.9353 44.3496 85.7517 44.0098H85.7283V47.0332H84.7087V38.9062H85.6755V39.9375H85.699C85.8904 39.5859 86.158 39.3086 86.5017 39.1055C86.8455 38.9023 87.2341 38.8008 87.6677 38.8008ZM87.4685 44.209C88.0115 44.209 88.4412 44.0059 88.7576 43.5996C89.074 43.1934 89.2322 42.6445 89.2322 41.9531C89.2322 41.2617 89.074 40.7129 88.7576 40.3066C88.4412 39.9004 88.0115 39.6973 87.4685 39.6973C86.9451 39.6973 86.5232 39.9043 86.2029 40.3184C85.8826 40.7324 85.7224 41.2773 85.7224 41.9531C85.7224 42.6328 85.8826 43.1797 86.2029 43.5938C86.5232 44.0039 86.9451 44.209 87.4685 44.209ZM94.2654 38.8008C95.0466 38.8008 95.6755 39.0879 96.1521 39.6621C96.6326 40.2363 96.8728 41 96.8728 41.9531C96.8728 42.9023 96.6345 43.666 96.158 44.2441C95.6814 44.8184 95.0583 45.1055 94.2888 45.1055C93.8591 45.1055 93.4744 45.0078 93.1345 44.8125C92.7947 44.6172 92.533 44.3496 92.3494 44.0098H92.3259V47.0332H91.3064V38.9062H92.2732V39.9375H92.2966C92.488 39.5859 92.7556 39.3086 93.0994 39.1055C93.4431 38.9023 93.8318 38.8008 94.2654 38.8008ZM94.0662 44.209C94.6091 44.209 95.0388 44.0059 95.3552 43.5996C95.6716 43.1934 95.8298 42.6445 95.8298 41.9531C95.8298 41.2617 95.6716 40.7129 95.3552 40.3066C95.0388 39.9004 94.6091 39.6973 94.0662 39.6973C93.5427 39.6973 93.1208 39.9043 92.8005 40.3184C92.4802 40.7324 92.3201 41.2773 92.3201 41.9531C92.3201 42.6328 92.4802 43.1797 92.8005 43.5938C93.1208 44.0039 93.5427 44.209 94.0662 44.209Z"
        fill="white"
      />
      <path
        d="M73.5063 18C75.111 18 76.7156 19.1988 77.0072 21.1968C77.685 25.8409 80.9256 28.6559 85.7593 28.6559L106.744 28.6559C111.701 28.6559 115.024 25.8409 115.719 21.1968C116.018 19.1988 117.664 18 119.309 18H73.5063Z"
        fill="#17161A"
      />
      <path
        d="M90.5727 21.8628C90.5727 23.7754 88.8747 25.3259 86.7801 25.3259C84.6855 25.3259 82.9875 23.7754 82.9875 21.8628C82.9875 19.9501 84.6855 18.3996 86.7801 18.3996C88.8747 18.3996 90.5727 19.9501 90.5727 21.8628Z"
        fill="#17171A"
        fill-opacity="0.01"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M86.7801 25.1927C88.7942 25.1927 90.4268 23.7018 90.4268 21.8628C90.4268 20.0237 88.7942 18.5328 86.7801 18.5328C84.7661 18.5328 83.1334 20.0237 83.1334 21.8628C83.1334 23.7018 84.7661 25.1927 86.7801 25.1927ZM86.7801 25.3259C88.8747 25.3259 90.5727 23.7754 90.5727 21.8628C90.5727 19.9501 88.8747 18.3996 86.7801 18.3996C84.6855 18.3996 82.9875 19.9501 82.9875 21.8628C82.9875 23.7754 84.6855 25.3259 86.7801 25.3259Z"
        fill="black"
        fill-opacity="0.6"
      />
      <mask
        id="path-26-outside-4"
        maskUnits="userSpaceOnUse"
        x="82.5713"
        y="17.9325"
        width="8"
        height="8"
        fill="black"
      >
        <rect fill="white" x="82.5713" y="17.9325" width="8" height="8" />
        <path
          d="M84.9238 23.5582C84.8099 23.4542 84.6252 23.4542 84.5113 23.5582C84.3973 23.6622 84.3973 23.8309 84.5113 23.9349C84.6252 24.039 84.8099 24.039 84.9238 23.9349C85.0378 23.8309 85.0378 23.6622 84.9238 23.5582Z"
        />
        <path
          d="M85.7756 19.6478C85.9244 19.5915 85.9951 19.4357 85.9335 19.2997C85.8718 19.1638 85.7012 19.0993 85.5523 19.1556C85.4034 19.2119 85.3328 19.3677 85.3944 19.5036C85.4561 19.6395 85.6267 19.7041 85.7756 19.6478Z"
        />
        <path
          d="M84.9238 20.1675C85.0378 20.0635 85.0378 19.8948 84.9238 19.7908C84.8099 19.6867 84.6252 19.6867 84.5113 19.7908C84.3973 19.8948 84.3973 20.0635 84.5113 20.1675C84.6252 20.2716 84.8099 20.2716 84.9238 20.1675Z"
        />
        <path
          d="M89.0496 20.1675C89.1635 20.0635 89.1635 19.8948 89.0496 19.7908C88.9357 19.6867 88.751 19.6867 88.637 19.7908C88.5231 19.8948 88.5231 20.0635 88.637 20.1675C88.751 20.2716 88.9357 20.2716 89.0496 20.1675Z"
        />
        <path
          d="M86.7804 19.4653C86.9415 19.4653 87.0721 19.346 87.0721 19.1989C87.0721 19.0518 86.9415 18.9325 86.7804 18.9325C86.6193 18.9325 86.4887 19.0518 86.4887 19.1989C86.4887 19.346 86.6193 19.4653 86.7804 19.4653Z"
        />
        <path
          d="M87.4758 23.4956C87.5564 23.6231 87.7348 23.6667 87.8744 23.5932C88.0139 23.5196 88.0617 23.3567 87.9812 23.2293C87.9006 23.1018 87.7222 23.0582 87.5826 23.1317C87.4431 23.2053 87.3953 23.3682 87.4758 23.4956Z"
        />
        <path
          d="M86.7804 24.7932C86.9415 24.7932 87.0721 24.674 87.0721 24.5268C87.0721 24.3797 86.9415 24.2604 86.7804 24.2604C86.6193 24.2604 86.4887 24.3797 86.4887 24.5268C86.4887 24.674 86.6193 24.7932 86.7804 24.7932Z"
        />
        <path
          d="M83.5713 21.8629C83.5713 22.01 83.7019 22.1293 83.863 22.1293C84.0241 22.1293 84.1548 22.01 84.1548 21.8629C84.1548 21.7157 84.0241 21.5965 83.863 21.5965C83.7019 21.5965 83.5713 21.7157 83.5713 21.8629Z"
        />
        <path
          d="M89.406 21.8629C89.406 22.01 89.5367 22.1293 89.6978 22.1293C89.8589 22.1293 89.9895 22.01 89.9895 21.8629C89.9895 21.7157 89.8589 21.5965 89.6978 21.5965C89.5367 21.5965 89.406 21.7157 89.406 21.8629Z"
        />
        <path
          d="M87.6273 19.2997C87.5656 19.4357 87.6363 19.5915 87.7852 19.6478C87.934 19.7041 88.1047 19.6395 88.1663 19.5036C88.228 19.3677 88.1573 19.2119 88.0085 19.1556C87.8596 19.0993 87.6889 19.1638 87.6273 19.2997Z"
        />
        <path
          d="M85.3944 24.2221C85.3328 24.358 85.4035 24.5139 85.5523 24.5702C85.7012 24.6265 85.8718 24.5619 85.9335 24.426C85.9951 24.2901 85.9245 24.1342 85.7756 24.0779C85.6267 24.0216 85.4561 24.0862 85.3944 24.2221Z"
        />
        <path
          d="M83.8156 20.7415C83.7539 20.8774 83.8246 21.0332 83.9734 21.0895C84.1223 21.1458 84.293 21.0813 84.3546 20.9453C84.4163 20.8094 84.3456 20.6536 84.1967 20.5973C84.0479 20.541 83.8772 20.6055 83.8156 20.7415Z"
        />
        <path
          d="M89.2062 22.7804C89.1445 22.9163 89.2152 23.0721 89.364 23.1284C89.5129 23.1847 89.6836 23.1202 89.7452 22.9843C89.8069 22.8483 89.7362 22.6925 89.5873 22.6362C89.4385 22.5799 89.2678 22.6444 89.2062 22.7804Z"
        />
        <path
          d="M87.7852 24.0779C87.6363 24.1342 87.5656 24.2901 87.6273 24.426C87.6889 24.5619 87.8596 24.6265 88.0084 24.5702C88.1573 24.5139 88.228 24.358 88.1663 24.2221C88.1047 24.0862 87.934 24.0216 87.7852 24.0779Z"
        />
        <path
          d="M83.8155 22.9843C83.8772 23.1202 84.0479 23.1847 84.1967 23.1284C84.3456 23.0721 84.4163 22.9163 84.3546 22.7804C84.2929 22.6444 84.1223 22.5799 83.9734 22.6362C83.8246 22.6925 83.7539 22.8483 83.8155 22.9843Z"
        />
        <path
          d="M89.364 20.5973C89.2152 20.6536 89.1445 20.8094 89.2061 20.9453C89.2678 21.0813 89.4385 21.1458 89.5873 21.0895C89.7362 21.0332 89.8069 20.8774 89.7452 20.7415C89.6835 20.6055 89.5129 20.541 89.364 20.5973Z"
        />
        <path
          d="M88.637 23.9349C88.751 24.039 88.9357 24.039 89.0496 23.9349C89.1635 23.8309 89.1635 23.6622 89.0496 23.5582C88.9357 23.4542 88.751 23.4542 88.637 23.5582C88.5231 23.6622 88.5231 23.8309 88.637 23.9349Z"
        />
        <path
          d="M86.7804 20.3977C86.9415 20.3977 87.0721 20.2784 87.0721 20.1313C87.0721 19.9842 86.9415 19.8649 86.7804 19.8649C86.6193 19.8649 86.4887 19.9842 86.4887 20.1313C86.4887 20.2784 86.6193 20.3977 86.7804 20.3977Z"
        />
        <path
          d="M86.7804 23.8608C86.9415 23.8608 87.0721 23.7416 87.0721 23.5944C87.0721 23.4473 86.9415 23.328 86.7804 23.328C86.6193 23.328 86.4887 23.4473 86.4887 23.5944C86.4887 23.7416 86.6193 23.8608 86.7804 23.8608Z"
        />
        <path
          d="M87.5826 20.594C87.7222 20.6675 87.9006 20.6239 87.9812 20.4965C88.0617 20.3691 88.0139 20.2061 87.8744 20.1326C87.7349 20.059 87.5564 20.1027 87.4759 20.2301C87.3953 20.3575 87.4431 20.5204 87.5826 20.594Z"
        />
        <path
          d="M85.6864 23.5932C85.8259 23.6667 86.0043 23.6231 86.0849 23.4956C86.1654 23.3682 86.1176 23.2053 85.9781 23.1317C85.8386 23.0582 85.6601 23.1018 85.5796 23.2293C85.499 23.3567 85.5468 23.5196 85.6864 23.5932Z"
        />
        <path
          d="M88.1699 21.1303C88.2505 21.2577 88.4289 21.3013 88.5685 21.2278C88.708 21.1542 88.7558 20.9913 88.6752 20.8639C88.5947 20.7365 88.4163 20.6928 88.2767 20.7664C88.1372 20.8399 88.0894 21.0029 88.1699 21.1303Z"
        />
        <path
          d="M84.8855 22.8618C84.966 22.9893 85.1444 23.0329 85.284 22.9594C85.4235 22.8858 85.4713 22.7229 85.3908 22.5955C85.3102 22.468 85.1318 22.4244 84.9922 22.4979C84.8527 22.5715 84.8049 22.7344 84.8855 22.8618Z"
        />
        <path
          d="M84.5923 21.8629C84.5923 22.01 84.7229 22.1293 84.884 22.1293C85.0452 22.1293 85.1758 22.01 85.1758 21.8629C85.1758 21.7157 85.0452 21.5965 84.884 21.5965C84.7229 21.5965 84.5923 21.7157 84.5923 21.8629Z"
        />
        <path
          d="M88.3849 21.8629C88.3849 22.01 88.5155 22.1293 88.6766 22.1293C88.8377 22.1293 88.9684 22.01 88.9684 21.8629C88.9684 21.7157 88.8377 21.5965 88.6766 21.5965C88.5155 21.5965 88.3849 21.7157 88.3849 21.8629Z"
        />
        <path
          d="M84.8855 20.8639C84.8049 20.9913 84.8527 21.1542 84.9922 21.2278C85.1318 21.3013 85.3102 21.2577 85.3908 21.1303C85.4713 21.0029 85.4235 20.8399 85.284 20.7664C85.1444 20.6928 84.966 20.7365 84.8855 20.8639Z"
        />
        <path
          d="M88.1699 22.5955C88.0894 22.7229 88.1372 22.8858 88.2767 22.9594C88.4163 23.0329 88.5947 22.9893 88.6752 22.8618C88.7558 22.7344 88.708 22.5715 88.5685 22.4979C88.4289 22.4244 88.2505 22.468 88.1699 22.5955Z"
        />
        <path
          d="M85.6863 20.1326C85.5468 20.2061 85.499 20.3691 85.5796 20.4965C85.6601 20.6239 85.8385 20.6675 85.9781 20.594C86.1176 20.5204 86.1654 20.3575 86.0849 20.2301C86.0043 20.1027 85.8259 20.059 85.6863 20.1326Z"
        />
        <path
          d="M86.7804 21.3301C86.9416 21.3301 87.0722 21.2108 87.0722 21.0637C87.0722 20.9165 86.9416 20.7973 86.7804 20.7973C86.6193 20.7973 86.4887 20.9165 86.4887 21.0637C86.4887 21.2108 86.6193 21.3301 86.7804 21.3301Z"
        />
        <path
          d="M86.7804 22.9284C86.9416 22.9284 87.0722 22.8092 87.0722 22.6621C87.0722 22.5149 86.9416 22.3957 86.7804 22.3957C86.6193 22.3957 86.4887 22.5149 86.4887 22.6621C86.4887 22.8092 86.6193 22.9284 86.7804 22.9284Z"
        />
        <path
          d="M87.2857 21.5965C87.3663 21.7239 87.5447 21.7675 87.6842 21.694C87.8238 21.6204 87.8716 21.4575 87.791 21.3301C87.7105 21.2027 87.532 21.159 87.3925 21.2326C87.253 21.3061 87.2051 21.469 87.2857 21.5965Z"
        />
        <path
          d="M85.7698 22.3957C85.8504 22.5231 86.0288 22.5667 86.1683 22.4932C86.3079 22.4196 86.3557 22.2567 86.2751 22.1293C86.1945 22.0018 86.0161 21.9582 85.8766 22.0317C85.737 22.1053 85.6892 22.2682 85.7698 22.3957Z"
        />
        <path
          d="M85.7698 21.3301C85.6892 21.4575 85.737 21.6204 85.8766 21.694C86.0161 21.7675 86.1945 21.7239 86.2751 21.5965C86.3557 21.469 86.3079 21.3061 86.1683 21.2326C86.0288 21.159 85.8504 21.2026 85.7698 21.3301Z"
        />
        <path
          d="M87.2857 22.1293C87.2051 22.2567 87.253 22.4196 87.3925 22.4932C87.532 22.5667 87.7105 22.5231 87.791 22.3957C87.8716 22.2682 87.8238 22.1053 87.6842 22.0317C87.5447 21.9582 87.3663 22.0018 87.2857 22.1293Z"
        />
        <path
          d="M86.7804 22.1293C86.9415 22.1293 87.0721 22.01 87.0721 21.8629C87.0721 21.7157 86.9415 21.5965 86.7804 21.5965C86.6193 21.5965 86.4887 21.7157 86.4887 21.8629C86.4887 22.01 86.6193 22.1293 86.7804 22.1293Z"
        />
      </mask>
      <g filter="url(#filter4_i)">
        <path
          d="M84.9238 23.5582C84.8099 23.4542 84.6252 23.4542 84.5113 23.5582C84.3973 23.6622 84.3973 23.8309 84.5113 23.9349C84.6252 24.039 84.8099 24.039 84.9238 23.9349C85.0378 23.8309 85.0378 23.6622 84.9238 23.5582Z"
          fill="#232228"
        />
        <path
          d="M85.7756 19.6478C85.9244 19.5915 85.9951 19.4357 85.9335 19.2997C85.8718 19.1638 85.7012 19.0993 85.5523 19.1556C85.4034 19.2119 85.3328 19.3677 85.3944 19.5036C85.4561 19.6395 85.6267 19.7041 85.7756 19.6478Z"
          fill="#232228"
        />
        <path
          d="M84.9238 20.1675C85.0378 20.0635 85.0378 19.8948 84.9238 19.7908C84.8099 19.6867 84.6252 19.6867 84.5113 19.7908C84.3973 19.8948 84.3973 20.0635 84.5113 20.1675C84.6252 20.2716 84.8099 20.2716 84.9238 20.1675Z"
          fill="#232228"
        />
        <path
          d="M89.0496 20.1675C89.1635 20.0635 89.1635 19.8948 89.0496 19.7908C88.9357 19.6867 88.751 19.6867 88.637 19.7908C88.5231 19.8948 88.5231 20.0635 88.637 20.1675C88.751 20.2716 88.9357 20.2716 89.0496 20.1675Z"
          fill="#232228"
        />
        <path
          d="M86.7804 19.4653C86.9415 19.4653 87.0721 19.346 87.0721 19.1989C87.0721 19.0518 86.9415 18.9325 86.7804 18.9325C86.6193 18.9325 86.4887 19.0518 86.4887 19.1989C86.4887 19.346 86.6193 19.4653 86.7804 19.4653Z"
          fill="#232228"
        />
        <path
          d="M87.4758 23.4956C87.5564 23.6231 87.7348 23.6667 87.8744 23.5932C88.0139 23.5196 88.0617 23.3567 87.9812 23.2293C87.9006 23.1018 87.7222 23.0582 87.5826 23.1317C87.4431 23.2053 87.3953 23.3682 87.4758 23.4956Z"
          fill="#232228"
        />
        <path
          d="M86.7804 24.7932C86.9415 24.7932 87.0721 24.674 87.0721 24.5268C87.0721 24.3797 86.9415 24.2604 86.7804 24.2604C86.6193 24.2604 86.4887 24.3797 86.4887 24.5268C86.4887 24.674 86.6193 24.7932 86.7804 24.7932Z"
          fill="#232228"
        />
        <path
          d="M83.5713 21.8629C83.5713 22.01 83.7019 22.1293 83.863 22.1293C84.0241 22.1293 84.1548 22.01 84.1548 21.8629C84.1548 21.7157 84.0241 21.5965 83.863 21.5965C83.7019 21.5965 83.5713 21.7157 83.5713 21.8629Z"
          fill="#232228"
        />
        <path
          d="M89.406 21.8629C89.406 22.01 89.5367 22.1293 89.6978 22.1293C89.8589 22.1293 89.9895 22.01 89.9895 21.8629C89.9895 21.7157 89.8589 21.5965 89.6978 21.5965C89.5367 21.5965 89.406 21.7157 89.406 21.8629Z"
          fill="#232228"
        />
        <path
          d="M87.6273 19.2997C87.5656 19.4357 87.6363 19.5915 87.7852 19.6478C87.934 19.7041 88.1047 19.6395 88.1663 19.5036C88.228 19.3677 88.1573 19.2119 88.0085 19.1556C87.8596 19.0993 87.6889 19.1638 87.6273 19.2997Z"
          fill="#232228"
        />
        <path
          d="M85.3944 24.2221C85.3328 24.358 85.4035 24.5139 85.5523 24.5702C85.7012 24.6265 85.8718 24.5619 85.9335 24.426C85.9951 24.2901 85.9245 24.1342 85.7756 24.0779C85.6267 24.0216 85.4561 24.0862 85.3944 24.2221Z"
          fill="#232228"
        />
        <path
          d="M83.8156 20.7415C83.7539 20.8774 83.8246 21.0332 83.9734 21.0895C84.1223 21.1458 84.293 21.0813 84.3546 20.9453C84.4163 20.8094 84.3456 20.6536 84.1967 20.5973C84.0479 20.541 83.8772 20.6055 83.8156 20.7415Z"
          fill="#232228"
        />
        <path
          d="M89.2062 22.7804C89.1445 22.9163 89.2152 23.0721 89.364 23.1284C89.5129 23.1847 89.6836 23.1202 89.7452 22.9843C89.8069 22.8483 89.7362 22.6925 89.5873 22.6362C89.4385 22.5799 89.2678 22.6444 89.2062 22.7804Z"
          fill="#232228"
        />
        <path
          d="M87.7852 24.0779C87.6363 24.1342 87.5656 24.2901 87.6273 24.426C87.6889 24.5619 87.8596 24.6265 88.0084 24.5702C88.1573 24.5139 88.228 24.358 88.1663 24.2221C88.1047 24.0862 87.934 24.0216 87.7852 24.0779Z"
          fill="#232228"
        />
        <path
          d="M83.8155 22.9843C83.8772 23.1202 84.0479 23.1847 84.1967 23.1284C84.3456 23.0721 84.4163 22.9163 84.3546 22.7804C84.2929 22.6444 84.1223 22.5799 83.9734 22.6362C83.8246 22.6925 83.7539 22.8483 83.8155 22.9843Z"
          fill="#232228"
        />
        <path
          d="M89.364 20.5973C89.2152 20.6536 89.1445 20.8094 89.2061 20.9453C89.2678 21.0813 89.4385 21.1458 89.5873 21.0895C89.7362 21.0332 89.8069 20.8774 89.7452 20.7415C89.6835 20.6055 89.5129 20.541 89.364 20.5973Z"
          fill="#232228"
        />
        <path
          d="M88.637 23.9349C88.751 24.039 88.9357 24.039 89.0496 23.9349C89.1635 23.8309 89.1635 23.6622 89.0496 23.5582C88.9357 23.4542 88.751 23.4542 88.637 23.5582C88.5231 23.6622 88.5231 23.8309 88.637 23.9349Z"
          fill="#232228"
        />
        <path
          d="M86.7804 20.3977C86.9415 20.3977 87.0721 20.2784 87.0721 20.1313C87.0721 19.9842 86.9415 19.8649 86.7804 19.8649C86.6193 19.8649 86.4887 19.9842 86.4887 20.1313C86.4887 20.2784 86.6193 20.3977 86.7804 20.3977Z"
          fill="#232228"
        />
        <path
          d="M86.7804 23.8608C86.9415 23.8608 87.0721 23.7416 87.0721 23.5944C87.0721 23.4473 86.9415 23.328 86.7804 23.328C86.6193 23.328 86.4887 23.4473 86.4887 23.5944C86.4887 23.7416 86.6193 23.8608 86.7804 23.8608Z"
          fill="#232228"
        />
        <path
          d="M87.5826 20.594C87.7222 20.6675 87.9006 20.6239 87.9812 20.4965C88.0617 20.3691 88.0139 20.2061 87.8744 20.1326C87.7349 20.059 87.5564 20.1027 87.4759 20.2301C87.3953 20.3575 87.4431 20.5204 87.5826 20.594Z"
          fill="#232228"
        />
        <path
          d="M85.6864 23.5932C85.8259 23.6667 86.0043 23.6231 86.0849 23.4956C86.1654 23.3682 86.1176 23.2053 85.9781 23.1317C85.8386 23.0582 85.6601 23.1018 85.5796 23.2293C85.499 23.3567 85.5468 23.5196 85.6864 23.5932Z"
          fill="#232228"
        />
        <path
          d="M88.1699 21.1303C88.2505 21.2577 88.4289 21.3013 88.5685 21.2278C88.708 21.1542 88.7558 20.9913 88.6752 20.8639C88.5947 20.7365 88.4163 20.6928 88.2767 20.7664C88.1372 20.8399 88.0894 21.0029 88.1699 21.1303Z"
          fill="#232228"
        />
        <path
          d="M84.8855 22.8618C84.966 22.9893 85.1444 23.0329 85.284 22.9594C85.4235 22.8858 85.4713 22.7229 85.3908 22.5955C85.3102 22.468 85.1318 22.4244 84.9922 22.4979C84.8527 22.5715 84.8049 22.7344 84.8855 22.8618Z"
          fill="#232228"
        />
        <path
          d="M84.5923 21.8629C84.5923 22.01 84.7229 22.1293 84.884 22.1293C85.0452 22.1293 85.1758 22.01 85.1758 21.8629C85.1758 21.7157 85.0452 21.5965 84.884 21.5965C84.7229 21.5965 84.5923 21.7157 84.5923 21.8629Z"
          fill="#232228"
        />
        <path
          d="M88.3849 21.8629C88.3849 22.01 88.5155 22.1293 88.6766 22.1293C88.8377 22.1293 88.9684 22.01 88.9684 21.8629C88.9684 21.7157 88.8377 21.5965 88.6766 21.5965C88.5155 21.5965 88.3849 21.7157 88.3849 21.8629Z"
          fill="#232228"
        />
        <path
          d="M84.8855 20.8639C84.8049 20.9913 84.8527 21.1542 84.9922 21.2278C85.1318 21.3013 85.3102 21.2577 85.3908 21.1303C85.4713 21.0029 85.4235 20.8399 85.284 20.7664C85.1444 20.6928 84.966 20.7365 84.8855 20.8639Z"
          fill="#232228"
        />
        <path
          d="M88.1699 22.5955C88.0894 22.7229 88.1372 22.8858 88.2767 22.9594C88.4163 23.0329 88.5947 22.9893 88.6752 22.8618C88.7558 22.7344 88.708 22.5715 88.5685 22.4979C88.4289 22.4244 88.2505 22.468 88.1699 22.5955Z"
          fill="#232228"
        />
        <path
          d="M85.6863 20.1326C85.5468 20.2061 85.499 20.3691 85.5796 20.4965C85.6601 20.6239 85.8385 20.6675 85.9781 20.594C86.1176 20.5204 86.1654 20.3575 86.0849 20.2301C86.0043 20.1027 85.8259 20.059 85.6863 20.1326Z"
          fill="#232228"
        />
        <path
          d="M86.7804 21.3301C86.9416 21.3301 87.0722 21.2108 87.0722 21.0637C87.0722 20.9165 86.9416 20.7973 86.7804 20.7973C86.6193 20.7973 86.4887 20.9165 86.4887 21.0637C86.4887 21.2108 86.6193 21.3301 86.7804 21.3301Z"
          fill="#232228"
        />
        <path
          d="M86.7804 22.9284C86.9416 22.9284 87.0722 22.8092 87.0722 22.6621C87.0722 22.5149 86.9416 22.3957 86.7804 22.3957C86.6193 22.3957 86.4887 22.5149 86.4887 22.6621C86.4887 22.8092 86.6193 22.9284 86.7804 22.9284Z"
          fill="#232228"
        />
        <path
          d="M87.2857 21.5965C87.3663 21.7239 87.5447 21.7675 87.6842 21.694C87.8238 21.6204 87.8716 21.4575 87.791 21.3301C87.7105 21.2027 87.532 21.159 87.3925 21.2326C87.253 21.3061 87.2051 21.469 87.2857 21.5965Z"
          fill="#232228"
        />
        <path
          d="M85.7698 22.3957C85.8504 22.5231 86.0288 22.5667 86.1683 22.4932C86.3079 22.4196 86.3557 22.2567 86.2751 22.1293C86.1945 22.0018 86.0161 21.9582 85.8766 22.0317C85.737 22.1053 85.6892 22.2682 85.7698 22.3957Z"
          fill="#232228"
        />
        <path
          d="M85.7698 21.3301C85.6892 21.4575 85.737 21.6204 85.8766 21.694C86.0161 21.7675 86.1945 21.7239 86.2751 21.5965C86.3557 21.469 86.3079 21.3061 86.1683 21.2326C86.0288 21.159 85.8504 21.2026 85.7698 21.3301Z"
          fill="#232228"
        />
        <path
          d="M87.2857 22.1293C87.2051 22.2567 87.253 22.4196 87.3925 22.4932C87.532 22.5667 87.7105 22.5231 87.791 22.3957C87.8716 22.2682 87.8238 22.1053 87.6842 22.0317C87.5447 21.9582 87.3663 22.0018 87.2857 22.1293Z"
          fill="#232228"
        />
        <path
          d="M86.7804 22.1293C86.9415 22.1293 87.0721 22.01 87.0721 21.8629C87.0721 21.7157 86.9415 21.5965 86.7804 21.5965C86.6193 21.5965 86.4887 21.7157 86.4887 21.8629C86.4887 22.01 86.6193 22.1293 86.7804 22.1293Z"
          fill="#232228"
        />
      </g>
      <path
        d="M84.9238 23.5582C84.8099 23.4542 84.6252 23.4542 84.5113 23.5582C84.3973 23.6622 84.3973 23.8309 84.5113 23.9349C84.6252 24.039 84.8099 24.039 84.9238 23.9349C85.0378 23.8309 85.0378 23.6622 84.9238 23.5582Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M85.7756 19.6478C85.9244 19.5915 85.9951 19.4357 85.9335 19.2997C85.8718 19.1638 85.7012 19.0993 85.5523 19.1556C85.4034 19.2119 85.3328 19.3677 85.3944 19.5036C85.4561 19.6395 85.6267 19.7041 85.7756 19.6478Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M84.9238 20.1675C85.0378 20.0635 85.0378 19.8948 84.9238 19.7908C84.8099 19.6867 84.6252 19.6867 84.5113 19.7908C84.3973 19.8948 84.3973 20.0635 84.5113 20.1675C84.6252 20.2716 84.8099 20.2716 84.9238 20.1675Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M89.0496 20.1675C89.1635 20.0635 89.1635 19.8948 89.0496 19.7908C88.9357 19.6867 88.751 19.6867 88.637 19.7908C88.5231 19.8948 88.5231 20.0635 88.637 20.1675C88.751 20.2716 88.9357 20.2716 89.0496 20.1675Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 19.4653C86.9415 19.4653 87.0721 19.346 87.0721 19.1989C87.0721 19.0518 86.9415 18.9325 86.7804 18.9325C86.6193 18.9325 86.4887 19.0518 86.4887 19.1989C86.4887 19.346 86.6193 19.4653 86.7804 19.4653Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M87.4758 23.4956C87.5564 23.6231 87.7348 23.6667 87.8744 23.5932C88.0139 23.5196 88.0617 23.3567 87.9812 23.2293C87.9006 23.1018 87.7222 23.0582 87.5826 23.1317C87.4431 23.2053 87.3953 23.3682 87.4758 23.4956Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 24.7932C86.9415 24.7932 87.0721 24.674 87.0721 24.5268C87.0721 24.3797 86.9415 24.2604 86.7804 24.2604C86.6193 24.2604 86.4887 24.3797 86.4887 24.5268C86.4887 24.674 86.6193 24.7932 86.7804 24.7932Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M83.5713 21.8629C83.5713 22.01 83.7019 22.1293 83.863 22.1293C84.0241 22.1293 84.1548 22.01 84.1548 21.8629C84.1548 21.7157 84.0241 21.5965 83.863 21.5965C83.7019 21.5965 83.5713 21.7157 83.5713 21.8629Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M89.406 21.8629C89.406 22.01 89.5367 22.1293 89.6978 22.1293C89.8589 22.1293 89.9895 22.01 89.9895 21.8629C89.9895 21.7157 89.8589 21.5965 89.6978 21.5965C89.5367 21.5965 89.406 21.7157 89.406 21.8629Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M87.6273 19.2997C87.5656 19.4357 87.6363 19.5915 87.7852 19.6478C87.934 19.7041 88.1047 19.6395 88.1663 19.5036C88.228 19.3677 88.1573 19.2119 88.0085 19.1556C87.8596 19.0993 87.6889 19.1638 87.6273 19.2997Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M85.3944 24.2221C85.3328 24.358 85.4035 24.5139 85.5523 24.5702C85.7012 24.6265 85.8718 24.5619 85.9335 24.426C85.9951 24.2901 85.9245 24.1342 85.7756 24.0779C85.6267 24.0216 85.4561 24.0862 85.3944 24.2221Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M83.8156 20.7415C83.7539 20.8774 83.8246 21.0332 83.9734 21.0895C84.1223 21.1458 84.293 21.0813 84.3546 20.9453C84.4163 20.8094 84.3456 20.6536 84.1967 20.5973C84.0479 20.541 83.8772 20.6055 83.8156 20.7415Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M89.2062 22.7804C89.1445 22.9163 89.2152 23.0721 89.364 23.1284C89.5129 23.1847 89.6836 23.1202 89.7452 22.9843C89.8069 22.8483 89.7362 22.6925 89.5873 22.6362C89.4385 22.5799 89.2678 22.6444 89.2062 22.7804Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M87.7852 24.0779C87.6363 24.1342 87.5656 24.2901 87.6273 24.426C87.6889 24.5619 87.8596 24.6265 88.0084 24.5702C88.1573 24.5139 88.228 24.358 88.1663 24.2221C88.1047 24.0862 87.934 24.0216 87.7852 24.0779Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M83.8155 22.9843C83.8772 23.1202 84.0479 23.1847 84.1967 23.1284C84.3456 23.0721 84.4163 22.9163 84.3546 22.7804C84.2929 22.6444 84.1223 22.5799 83.9734 22.6362C83.8246 22.6925 83.7539 22.8483 83.8155 22.9843Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M89.364 20.5973C89.2152 20.6536 89.1445 20.8094 89.2061 20.9453C89.2678 21.0813 89.4385 21.1458 89.5873 21.0895C89.7362 21.0332 89.8069 20.8774 89.7452 20.7415C89.6835 20.6055 89.5129 20.541 89.364 20.5973Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M88.637 23.9349C88.751 24.039 88.9357 24.039 89.0496 23.9349C89.1635 23.8309 89.1635 23.6622 89.0496 23.5582C88.9357 23.4542 88.751 23.4542 88.637 23.5582C88.5231 23.6622 88.5231 23.8309 88.637 23.9349Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 20.3977C86.9415 20.3977 87.0721 20.2784 87.0721 20.1313C87.0721 19.9842 86.9415 19.8649 86.7804 19.8649C86.6193 19.8649 86.4887 19.9842 86.4887 20.1313C86.4887 20.2784 86.6193 20.3977 86.7804 20.3977Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 23.8608C86.9415 23.8608 87.0721 23.7416 87.0721 23.5944C87.0721 23.4473 86.9415 23.328 86.7804 23.328C86.6193 23.328 86.4887 23.4473 86.4887 23.5944C86.4887 23.7416 86.6193 23.8608 86.7804 23.8608Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M87.5826 20.594C87.7222 20.6675 87.9006 20.6239 87.9812 20.4965C88.0617 20.3691 88.0139 20.2061 87.8744 20.1326C87.7349 20.059 87.5564 20.1027 87.4759 20.2301C87.3953 20.3575 87.4431 20.5204 87.5826 20.594Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M85.6864 23.5932C85.8259 23.6667 86.0043 23.6231 86.0849 23.4956C86.1654 23.3682 86.1176 23.2053 85.9781 23.1317C85.8386 23.0582 85.6601 23.1018 85.5796 23.2293C85.499 23.3567 85.5468 23.5196 85.6864 23.5932Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M88.1699 21.1303C88.2505 21.2577 88.4289 21.3013 88.5685 21.2278C88.708 21.1542 88.7558 20.9913 88.6752 20.8639C88.5947 20.7365 88.4163 20.6928 88.2767 20.7664C88.1372 20.8399 88.0894 21.0029 88.1699 21.1303Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M84.8855 22.8618C84.966 22.9893 85.1444 23.0329 85.284 22.9594C85.4235 22.8858 85.4713 22.7229 85.3908 22.5955C85.3102 22.468 85.1318 22.4244 84.9922 22.4979C84.8527 22.5715 84.8049 22.7344 84.8855 22.8618Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M84.5923 21.8629C84.5923 22.01 84.7229 22.1293 84.884 22.1293C85.0452 22.1293 85.1758 22.01 85.1758 21.8629C85.1758 21.7157 85.0452 21.5965 84.884 21.5965C84.7229 21.5965 84.5923 21.7157 84.5923 21.8629Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M88.3849 21.8629C88.3849 22.01 88.5155 22.1293 88.6766 22.1293C88.8377 22.1293 88.9684 22.01 88.9684 21.8629C88.9684 21.7157 88.8377 21.5965 88.6766 21.5965C88.5155 21.5965 88.3849 21.7157 88.3849 21.8629Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M84.8855 20.8639C84.8049 20.9913 84.8527 21.1542 84.9922 21.2278C85.1318 21.3013 85.3102 21.2577 85.3908 21.1303C85.4713 21.0029 85.4235 20.8399 85.284 20.7664C85.1444 20.6928 84.966 20.7365 84.8855 20.8639Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M88.1699 22.5955C88.0894 22.7229 88.1372 22.8858 88.2767 22.9594C88.4163 23.0329 88.5947 22.9893 88.6752 22.8618C88.7558 22.7344 88.708 22.5715 88.5685 22.4979C88.4289 22.4244 88.2505 22.468 88.1699 22.5955Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M85.6863 20.1326C85.5468 20.2061 85.499 20.3691 85.5796 20.4965C85.6601 20.6239 85.8385 20.6675 85.9781 20.594C86.1176 20.5204 86.1654 20.3575 86.0849 20.2301C86.0043 20.1027 85.8259 20.059 85.6863 20.1326Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 21.3301C86.9416 21.3301 87.0722 21.2108 87.0722 21.0637C87.0722 20.9165 86.9416 20.7973 86.7804 20.7973C86.6193 20.7973 86.4887 20.9165 86.4887 21.0637C86.4887 21.2108 86.6193 21.3301 86.7804 21.3301Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 22.9284C86.9416 22.9284 87.0722 22.8092 87.0722 22.6621C87.0722 22.5149 86.9416 22.3957 86.7804 22.3957C86.6193 22.3957 86.4887 22.5149 86.4887 22.6621C86.4887 22.8092 86.6193 22.9284 86.7804 22.9284Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M87.2857 21.5965C87.3663 21.7239 87.5447 21.7675 87.6842 21.694C87.8238 21.6204 87.8716 21.4575 87.791 21.3301C87.7105 21.2027 87.532 21.159 87.3925 21.2326C87.253 21.3061 87.2051 21.469 87.2857 21.5965Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M85.7698 22.3957C85.8504 22.5231 86.0288 22.5667 86.1683 22.4932C86.3079 22.4196 86.3557 22.2567 86.2751 22.1293C86.1945 22.0018 86.0161 21.9582 85.8766 22.0317C85.737 22.1053 85.6892 22.2682 85.7698 22.3957Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M85.7698 21.3301C85.6892 21.4575 85.737 21.6204 85.8766 21.694C86.0161 21.7675 86.1945 21.7239 86.2751 21.5965C86.3557 21.469 86.3079 21.3061 86.1683 21.2326C86.0288 21.159 85.8504 21.2026 85.7698 21.3301Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M87.2857 22.1293C87.2051 22.2567 87.253 22.4196 87.3925 22.4932C87.532 22.5667 87.7105 22.5231 87.791 22.3957C87.8716 22.2682 87.8238 22.1053 87.6842 22.0317C87.5447 21.9582 87.3663 22.0018 87.2857 22.1293Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <path
        d="M86.7804 22.1293C86.9415 22.1293 87.0721 22.01 87.0721 21.8629C87.0721 21.7157 86.9415 21.5965 86.7804 21.5965C86.6193 21.5965 86.4887 21.7157 86.4887 21.8629C86.4887 22.01 86.6193 22.1293 86.7804 22.1293Z"
        stroke="#1E1E1E"
        stroke-opacity="0.93"
        mask="url(#path-26-outside-4)"
      />
      <g filter="url(#filter5_ii)">
        <path
          d="M109.828 21.8628C109.828 23.7754 108.13 25.3259 106.035 25.3259C103.94 25.3259 102.242 23.7754 102.242 21.8628C102.242 19.9501 103.94 18.3996 106.035 18.3996C108.13 18.3996 109.828 19.9501 109.828 21.8628Z"
          fill="#111113"
          fill-opacity="0.17"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.035 25.1927C108.049 25.1927 109.682 23.7018 109.682 21.8628C109.682 20.0237 108.049 18.5328 106.035 18.5328C104.021 18.5328 102.388 20.0237 102.388 21.8628C102.388 23.7018 104.021 25.1927 106.035 25.1927ZM106.035 25.3259C108.13 25.3259 109.828 23.7754 109.828 21.8628C109.828 19.9501 108.13 18.3996 106.035 18.3996C103.94 18.3996 102.242 19.9501 102.242 21.8628C102.242 23.7754 103.94 25.3259 106.035 25.3259Z"
        fill="black"
        fill-opacity="0.6"
      />
      <path
        d="M108.661 21.8627C108.661 23.1869 107.485 24.2603 106.035 24.2603C104.585 24.2603 103.409 23.1869 103.409 21.8627C103.409 20.5386 104.585 19.4651 106.035 19.4651C107.485 19.4651 108.661 20.5386 108.661 21.8627Z"
        fill="url(#paint11_linear)"
      />
      <path
        d="M108.661 21.8627C108.661 23.1869 107.485 24.2603 106.035 24.2603C104.585 24.2603 103.409 23.1869 103.409 21.8627C103.409 20.5386 104.585 19.4651 106.035 19.4651C107.485 19.4651 108.661 20.5386 108.661 21.8627Z"
        fill="url(#paint12_radial)"
      />
      <path
        d="M108.661 21.8627C108.661 23.1869 107.485 24.2603 106.035 24.2603C104.585 24.2603 103.409 23.1869 103.409 21.8627C103.409 20.5386 104.585 19.4651 106.035 19.4651C107.485 19.4651 108.661 20.5386 108.661 21.8627Z"
        fill="url(#paint13_radial)"
      />
      <g filter="url(#filter6_i)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M108.806 21.8627C108.806 23.2604 107.566 24.3935 106.035 24.3935C104.504 24.3935 103.263 23.2604 103.263 21.8627C103.263 20.465 104.504 19.332 106.035 19.332C107.566 19.332 108.806 20.465 108.806 21.8627ZM106.035 24.2603C107.485 24.2603 108.661 23.1869 108.661 21.8627C108.661 20.5386 107.485 19.4652 106.035 19.4652C104.585 19.4652 103.409 20.5386 103.409 21.8627C103.409 23.1869 104.585 24.2603 106.035 24.2603Z"
          fill="#0C0B0D"
        />
      </g>
      <g opacity="0.7" filter="url(#filter7_f)">
        <ellipse
          rx="0.856846"
          ry="1.22829"
          transform="matrix(0.884597 0.466355 -0.534415 0.845222 105.407 21.4358)"
          fill="url(#paint14_linear)"
        />
      </g>
      <path
        d="M134.796 26.0703C134.392 26.0703 134.054 25.9561 133.782 25.7275C133.513 25.499 133.367 25.2051 133.346 24.8457H133.864C133.888 25.0703 133.986 25.2539 134.16 25.3965C134.334 25.5371 134.548 25.6074 134.802 25.6074C135.089 25.6074 135.322 25.5176 135.502 25.3379C135.684 25.1582 135.774 24.9258 135.774 24.6406C135.774 24.3555 135.684 24.1221 135.502 23.9404C135.322 23.7568 135.092 23.665 134.811 23.665C134.613 23.665 134.435 23.707 134.274 23.791C134.114 23.875 133.991 23.9912 133.905 24.1396H133.41L133.642 21.7725H136.062V22.2412H134.075L133.946 23.6182H133.958C134.054 23.4912 134.185 23.3916 134.351 23.3193C134.519 23.2471 134.703 23.2109 134.904 23.2109C135.311 23.2109 135.645 23.3447 135.906 23.6123C136.17 23.8779 136.302 24.2158 136.302 24.626C136.302 25.0498 136.161 25.3965 135.88 25.666C135.599 25.9355 135.237 26.0703 134.796 26.0703ZM138.332 26.0703C137.842 26.0703 137.459 25.875 137.184 25.4844C136.91 25.0918 136.773 24.5586 136.773 23.8848C136.773 23.2168 136.911 22.6865 137.187 22.2939C137.464 21.8994 137.846 21.7021 138.332 21.7021C138.818 21.7021 139.198 21.8984 139.472 22.291C139.747 22.6816 139.885 23.2119 139.885 23.8818C139.885 24.5557 139.748 25.0889 139.475 25.4814C139.201 25.874 138.82 26.0703 138.332 26.0703ZM137.573 25.1475C137.753 25.4561 138.006 25.6104 138.332 25.6104C138.658 25.6104 138.91 25.457 139.088 25.1504C139.266 24.8418 139.354 24.4199 139.354 23.8848C139.354 23.3574 139.265 22.9395 139.085 22.6309C138.905 22.3203 138.654 22.165 138.332 22.165C138.01 22.165 137.758 22.3203 137.576 22.6309C137.395 22.9414 137.304 23.3584 137.304 23.8818C137.304 24.417 137.394 24.8389 137.573 25.1475ZM141.827 22.0068C141.989 22.1982 142.07 22.4531 142.07 22.7715C142.07 23.0898 141.989 23.3447 141.827 23.5361C141.665 23.7275 141.45 23.8232 141.183 23.8232C140.915 23.8232 140.7 23.7275 140.538 23.5361C140.376 23.3447 140.295 23.0898 140.295 22.7715C140.295 22.4531 140.376 22.1982 140.538 22.0068C140.7 21.8154 140.915 21.7197 141.183 21.7197C141.45 21.7197 141.665 21.8154 141.827 22.0068ZM140.875 23.2812C140.951 23.4043 141.054 23.4658 141.183 23.4658C141.312 23.4658 141.413 23.4043 141.487 23.2812C141.563 23.1562 141.602 22.9863 141.602 22.7715C141.602 22.5566 141.563 22.3877 141.487 22.2646C141.413 22.1396 141.312 22.0771 141.183 22.0771C141.054 22.0771 140.951 22.1396 140.875 22.2646C140.801 22.3877 140.764 22.5566 140.764 22.7715C140.764 22.9863 140.801 23.1562 140.875 23.2812ZM141.054 26H140.544L142.176 23.7705L143.638 21.7725H144.142L142.554 23.9463L141.054 26ZM144.15 24.2275C144.312 24.4189 144.394 24.6738 144.394 24.9922C144.394 25.3105 144.312 25.5654 144.15 25.7568C143.988 25.9482 143.773 26.0439 143.506 26.0439C143.238 26.0439 143.023 25.9482 142.861 25.7568C142.699 25.5654 142.618 25.3105 142.618 24.9922C142.618 24.6738 142.699 24.4189 142.861 24.2275C143.023 24.0361 143.238 23.9404 143.506 23.9404C143.773 23.9404 143.988 24.0361 144.15 24.2275ZM143.198 25.502C143.274 25.625 143.377 25.6865 143.506 25.6865C143.635 25.6865 143.736 25.625 143.811 25.502C143.887 25.377 143.925 25.207 143.925 24.9922C143.925 24.7773 143.887 24.6084 143.811 24.4854C143.736 24.3604 143.635 24.2979 143.506 24.2979C143.377 24.2979 143.274 24.3604 143.198 24.4854C143.124 24.6084 143.087 24.7773 143.087 24.9922C143.087 25.207 143.124 25.377 143.198 25.502Z"
        fill="white"
      />
      <path
        d="M17 53H175V310C175 313.314 172.314 316 169 316H23C19.6863 316 17 313.314 17 310V53Z"
        fill="white"
      />
      <path
        d="M25.25 45.5H38.75V44H25.25V45.5ZM25.25 41.75H38.75V40.25H25.25V41.75ZM25.25 36.5V38H38.75V36.5H25.25Z"
        fill="white"
      />
      <path
        d="M160.333 42.3333H159.807L159.62 42.1533C160.273 41.3933 160.667 40.4067 160.667 39.3333C160.667 36.94 158.727 35 156.333 35C153.94 35 152 36.94 152 39.3333C152 41.7267 153.94 43.6667 156.333 43.6667C157.407 43.6667 158.393 43.2733 159.153 42.62L159.333 42.8067V43.3333L162.667 46.66L163.66 45.6667L160.333 42.3333V42.3333ZM156.333 42.3333C154.673 42.3333 153.333 40.9933 153.333 39.3333C153.333 37.6733 154.673 36.3333 156.333 36.3333C157.993 36.3333 159.333 37.6733 159.333 39.3333C159.333 40.9933 157.993 42.3333 156.333 42.3333Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i"
          x="179.541"
          y="69.5397"
          width="3.45865"
          height="42.6235"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter1_i"
          x="179.541"
          y="125.749"
          width="3.45865"
          height="18.9142"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter2_ii"
          x="10"
          y="10"
          width="171.979"
          height="329"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="7" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="19" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.82 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow"
            result="effect2_innerShadow"
          />
        </filter>
        <filter
          id="filter3_ddi"
          x="0.750732"
          y="0.59845"
          width="190.478"
          height="347.803"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="overlay"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.95 0"
          />
          <feBlend
            mode="soft-light"
            in2="effect1_dropShadow"
            result="effect2_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
          />
          <feBlend mode="multiply" in2="shape" result="effect3_innerShadow" />
        </filter>
        <filter
          id="filter4_i"
          x="83.0713"
          y="18.4325"
          width="8.41822"
          height="7.86073"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.72 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter5_ii"
          x="102.242"
          y="18.3996"
          width="7.5852"
          height="6.92632"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.1 0 0 0 0 0.1 0 0 0 0 0.1 0 0 0 0.6 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.222707 0 0 0 0 0.222707 0 0 0 0 0.222707 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow"
            result="effect2_innerShadow"
          />
        </filter>
        <filter
          id="filter6_i"
          x="103.263"
          y="19.332"
          width="5.54298"
          height="6.06154"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.224326 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter7_f"
          x="101.405"
          y="17.3231"
          width="8.00541"
          height="8.22545"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="1.5" result="effect1_foregroundBlur" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="182.27"
          y1="69.5397"
          x2="182.27"
          y2="112.163"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1E1D28" />
          <stop offset="0.0178393" stop-color="#B4B3BE" />
          <stop offset="0.0507986" stop-color="#54545C" />
          <stop offset="0.941967" stop-color="#474650" />
          <stop offset="0.982533" stop-color="#78777F" />
          <stop offset="1" stop-color="#1E1D28" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="182.27"
          y1="125.749"
          x2="182.27"
          y2="144.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1E1D28" />
          <stop offset="0.0178393" stop-color="#B4B3BE" />
          <stop offset="0.0507986" stop-color="#54545C" />
          <stop offset="0.941967" stop-color="#474650" />
          <stop offset="0.982533" stop-color="#78777F" />
          <stop offset="1" stop-color="#1E1D28" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="96.0624"
          y1="336.869"
          x2="96.0624"
          y2="338.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#777777" stop-opacity="0.86" />
          <stop offset="1" stop-color="#A3A3A3" stop-opacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="96.0624"
          y1="336.869"
          x2="96.0624"
          y2="338.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#777777" stop-opacity="0.86" />
          <stop offset="1" stop-color="#A3A3A3" stop-opacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="96.0624"
          y1="10.0607"
          x2="96.0624"
          y2="12.1309"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A3A3A3" stop-opacity="0.2" />
          <stop offset="1" stop-color="#777777" stop-opacity="0.86" />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="96.0624"
          y1="10.0607"
          x2="96.0624"
          y2="12.1309"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A3A3A3" stop-opacity="0.2" />
          <stop offset="1" stop-color="#777777" stop-opacity="0.86" />
        </linearGradient>
        <linearGradient
          id="paint6_linear"
          x1="95.9896"
          y1="13.1968"
          x2="95.9896"
          y2="335.803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#17171A" />
          <stop offset="1" stop-color="#17161A" />
        </linearGradient>
        <linearGradient
          id="paint7_linear"
          x1="178.478"
          y1="174.5"
          x2="172.935"
          y2="174.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B1B1B1" stop-opacity="0.35" />
          <stop offset="1" stop-color="#484848" stop-opacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint8_linear"
          x1="13.4882"
          y1="174.5"
          x2="19.0312"
          y2="174.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B1B1B1" stop-opacity="0.35" />
          <stop offset="1" stop-color="#484848" stop-opacity="0.4" />
        </linearGradient>
        <linearGradient
          id="paint9_linear"
          x1="96.0624"
          y1="319.953"
          x2="96.0624"
          y2="331.941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#45444E" />
          <stop offset="1" stop-color="#302F35" />
        </linearGradient>
        <radialGradient
          id="paint10_angular"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(96.0624 325.947) rotate(90) scale(5.99396 6.56408)"
        >
          <stop offset="0.176245" stop-opacity="0.32" />
          <stop offset="0.26847" stop-color="white" stop-opacity="0.03" />
          <stop offset="0.306183" stop-color="#F5F5F5" />
          <stop offset="0.343727" stop-opacity="0.41" />
          <stop offset="0.502884" stop-opacity="0.43" />
          <stop offset="0.656394" stop-color="#101010" stop-opacity="0.52" />
          <stop offset="0.699482" stop-color="white" stop-opacity="0.36" />
          <stop offset="0.767284" stop-color="#E6E6E6" stop-opacity="0.09" />
          <stop offset="0.837557" stop-opacity="0.09" />
          <stop offset="1" stop-opacity="0.25" />
        </radialGradient>
        <linearGradient
          id="paint11_linear"
          x1="103.993"
          y1="19.9313"
          x2="107.707"
          y2="23.9989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#05406B" />
          <stop offset="1" />
        </linearGradient>
        <radialGradient
          id="paint12_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(103.847 20.0645) rotate(42.4004) scale(3.65437 3.63934)"
        >
          <stop stop-color="#2F9AFC" stop-opacity="0.5" />
          <stop offset="1" stop-opacity="0.5" />
        </radialGradient>
        <radialGradient
          id="paint13_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(107.785 23.3945) rotate(42.4004) scale(1.58027 1.88089)"
        >
          <stop stop-color="#1F699F" stop-opacity="0.5" />
          <stop offset="1" stop-opacity="0.5" />
        </radialGradient>
        <linearGradient
          id="paint14_linear"
          x1="1.36111"
          y1="1.29766"
          x2="-0.092734"
          y2="0.890036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.01" />
          <stop offset="1" stop-color="#C5E3FF" />
        </linearGradient>
      </defs>
    </svg>
    <div class="note scrollbar_basic">
      <div v-if="message" class="note-container">
        <p
          style="text-align: left"
          class="body-1 message"
          :data-test="DATA_TEST.SHARED.PREVIEW_PHONE_MESSAGE"
        >
          {{ message }}
        </p>
        <p style="text-align: right" class="body-1 date">14:15</p>
      </div>
      <div v-else class="note-container">
        <p style="text-align: left" class="body-1 message">...</p>
        <p style="text-align: right" class="body-1 date">14:15</p>
      </div>
    </div>
  </div>
</template>
<script>
import { DATA_TEST } from '@/app/shared/utils/dataTest'

export default {
  name: 'Phone',
  props: {
    message: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    DATA_TEST,
  }),
}
</script>
<style lang="sass" scoped>
.phone
  position: absolute
  right: 23px
  bottom: 18px
.note
  background-color: $white_000
  height: 18em
  width: 11em
  position: absolute
  right: 19px
  top: 56px
  display: flex
  align-items: flex-start
  justify-content: center
  overflow-y: auto
  .note-container
    margin-top: 8px
    width: 136px
    padding: 12px
    border-radius: 8px
    background-color: $blue_light_000
    .message
      margin-bottom: 4px
      color: $gray_dark_900
      white-space: pre-line
    .date
      margin-bottom: 0px
      color: $gray_dark_800
    pre
      white-space: pre-wrap       // Since CSS 2.1
      white-space: -moz-pre-wrap  // Mozilla, since 1999
      white-space: -pre-wrap      // Opera 4-6
      white-space: -o-pre-wrap    //Opera 7
      word-wrap: break-word       // Internet Explorer 5.5+
</style>
